export enum TrimStatus {
	Missed = 'last_trims',
}
